<template>
  <div class="calculator-wrapper">
    <BadCredit v-if="name === 'bad-credit'"/>
    <BuyToLet v-else-if="name === 'buy-to-let'"/>
    <EquityRelease v-else-if="name === 'equity-release'"/>
    <MortgageAffordability v-else-if="name === 'mortgage-affordability'"/>
    <HelpToBuy v-else-if="name === 'help-to-buy'"/>
    <InterestOnly v-else-if="name === 'interest-only'"/>
    <Repayment v-else-if="name === 'repayment'"/>
    <RightToBuyDiscount v-else-if="name === 'right-to-buy-discount'"/>
    <RightToBuyMortgage v-else-if="name === 'right-to-buy-mortgage'"/>
    <SelfEmployed v-else-if="name === 'self-employed'"/>
    <StampDuty v-else-if="name === 'stamp-duty'"/>
    <Remortgage v-else-if="name === 'remortgage'"/>
    <FirstTimeBuyer v-else-if="name === 'first-time-buyer'"/>

    <div class="container" v-else>
      <h3>Please add the correct calculator name from the list provided</h3>
      <div>You are trying to add: {{ name }}</div>
    </div>
  </div>
</template>

<script>
import BadCredit from '@/components/BadCredit.vue'
import BuyToLet from '@/components/BuyToLet.vue'
import EquityRelease from '@/components/EquityRelease.vue'
import MortgageAffordability from '@/components/MortgageAffordability.vue'
import HelpToBuy from './components/HelpToBuy.vue'
import InterestOnly from './components/InterestOnly.vue'
import Repayment from './components/Repayment.vue'
import RightToBuyDiscount from './components/RightToBuyDiscount.vue'
import RightToBuyMortgage from './components/RightToBuyMortgage.vue'
import SelfEmployed from './components/SelfEmployed.vue'
import StampDuty from './components/StampDuty.vue'
import Remortgage from "./components/Remortgage.vue";
import FirstTimeBuyer from "./components/FirstTimeBuyer.vue";

export default {
  name: 'Mortagage Calculators',
  components: {
    BadCredit,
    BuyToLet,
    FirstTimeBuyer,
    EquityRelease,
    MortgageAffordability,
    HelpToBuy,
    InterestOnly,
    Repayment,
    RightToBuyDiscount,
    RightToBuyMortgage,
    SelfEmployed,
    StampDuty,
    Remortgage
  },
  props: {
    name: {
      type: String
    }
  }
}
</script>

<style lang="scss">
  .calculator-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }
</style>
